import { parseRichText, paragraphsFrom } from '../../lib/richText'
import styles from './DealPanel.module.css'

/**
 * Renders model-written narrative as real elements.
 *
 * Structured text (headings, bullets) is parsed; plain prose is grouped into
 * readable paragraphs. React escapes every string on the way in, so there is no
 * markup assembly anywhere in this path.
 */
export function Prose({ text }: { text: string }) {
  const blocks = parseRichText(text)
  const hasStructure = blocks.some((b) => b.kind === 'heading' || b.kind === 'list')

  if (!hasStructure) {
    const paragraphs = paragraphsFrom(text)
    if (paragraphs.length === 0) return null
    return (
      <div className={styles.prose}>
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    )
  }

  return (
    <div className={styles.prose}>
      {blocks.map((block, index) => {
        if (block.kind === 'heading') {
          return (
            <p key={index} className={styles.proseHeading}>
              {block.text}
            </p>
          )
        }
        if (block.kind === 'list') {
          return (
            <ul key={index} className={styles.proseList}>
              {block.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )
        }
        return <p key={index}>{block.text}</p>
      })}
    </div>
  )
}
